import { render, staticRenderFns } from "./HelpDeskForm.vue?vue&type=template&id=67d02c24&scoped=true"
import script from "./HelpDeskForm.vue?vue&type=script&lang=js"
export * from "./HelpDeskForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d02c24",
  null
  
)

export default component.exports